import { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { lddGlobalSessionInfo } from "../navigationTypes";

type BuilderInfoType = {
    projectName: string,
    fromLawyer: string,
    fromLawyerClerk: string,
    toLawyer: string,
    legalDesc: string,
    propertyAddr: string,
    fromLawyerClient: string,
    toLawyerClient: string,
}

type BuilderInfoPropsType = {
    sessionInfo: lddGlobalSessionInfo,
    msgID: string,
}

const BuilderInfo = (props: BuilderInfoPropsType) => {
    const [BuilderInfo, setBuilderInfo] = useState<BuilderInfoType>({projectName: "", fromLawyer: "", fromLawyerClerk: "", fromLawyerClient: "", toLawyer: "", toLawyerClient: "", propertyAddr: "", legalDesc: ""});

    useEffect(() => {
        if (props.msgID > "") {
            const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${props.sessionInfo.firm.id}/${props.sessionInfo.user.account}/msginfo?SessionID=${props.sessionInfo.sid}&MsgID=${props.msgID}`;
            fetch(url).then((res) => {
                if (res.ok) {
                    res.json().then((resJson) => {
                        if (resJson.ok) {
                            const result: BuilderInfoType = resJson.result;
                            setBuilderInfo(result);
                        }
                    })
                }
            });
        }
        
    }, [props.msgID]);

    return <Card style={{ height: '100%', width: '100%', position: 'relative' }}>
        <Card.Header>
            <Card.Title>Builder Project Information</Card.Title>
        </Card.Header>

        <Card.Body className="pt-3" style={{ overflow: "auto" }}>
            <Row className="mb-3">
                <Col className="col-8">
                    <Form.Label>Name of Project</Form.Label>
                    <Form.Control
                        name='projName'
                        readOnly
                        value={BuilderInfo.projectName ?? ""}
                    />
                </Col>
                <Col>
                    <Form.Label>Lawyer</Form.Label>
                    <Form.Control
                        name='lawyerName'
                        readOnly
                        value={BuilderInfo.fromLawyer ?? ""}
                    />
                </Col>
                {/* <Col>
                    <Form.Label>To</Form.Label>
                    <Form.Control
                        name='to'
                        value={BuilderInfo.toLawyer ?? ""}
                        readOnly
                    />
                </Col> */}
            </Row>

            <Row className="mb-3">
                <Col className="col-8">
                    <Form.Label>Property Address</Form.Label>
                    <Form.Control
                        name='propertyAddress'
                        readOnly
                        value={BuilderInfo.propertyAddr ?? ""}
                    />
                </Col>
                <Col>
                    <Form.Label>Clerk</Form.Label>
                    <Form.Control
                        name='clerkName'
                        readOnly
                        value={BuilderInfo.fromLawyerClerk ?? ""}
                    />
                </Col>
            </Row>
            <Row>
                <Col className="col-8">
                    <Form.Label>Legal Description</Form.Label>
                    <Form.Control
                        name='legalDesc'
                        readOnly
                        as="textarea"
                        value={(BuilderInfo.legalDesc ?? "").replace("<br>", "\n")}
                    />
                </Col>
                <Col>
                    <Form.Label>Declarant</Form.Label>
                    <Form.Control
                        name='declarant'
                        readOnly
                        value={BuilderInfo.fromLawyerClient ?? ""}
                    />
                </Col>
                {/* <Col>
                    <Form.Label>Client Name</Form.Label>
                        <Form.Control
                            name='clientName'
                            readOnly
                            value={BuilderInfo.toLawyerClient ?? ""}
                    />
                </Col> */}
            </Row>

        </Card.Body>
    </Card>
}

export default BuilderInfo;